function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React, { useRef, useEffect, useState } from 'react';
import ReactDom from 'react-dom';
import classnames from 'classnames';
import classes from './scalable-font-size-input.scss';
export function ScalableFontSizeInputComponent(props) {
  const {
      className,
      value,
      maxFontSize,
      minFontSize,
      maxDigits,
      onChange
    } = props,
    inputProps = _objectWithoutProperties(props, ["className", "value", "maxFontSize", "minFontSize", "maxDigits", "onChange"]);
  const [calculatedFontSize, setCalculatedFontSize] = useState(maxFontSize);
  const inputRef = useRef(null);
  const textRef = useRef(null);
  const resizeFontSize = () => {
    var _inputRef$current$cli, _inputRef$current, _textRef$current$clie, _textRef$current;
    const inputSize = (_inputRef$current$cli = (_inputRef$current = inputRef.current) === null || _inputRef$current === void 0 ? void 0 : _inputRef$current.clientWidth) !== null && _inputRef$current$cli !== void 0 ? _inputRef$current$cli : 0;
    const textSize = (_textRef$current$clie = (_textRef$current = textRef.current) === null || _textRef$current === void 0 ? void 0 : _textRef$current.clientWidth) !== null && _textRef$current$clie !== void 0 ? _textRef$current$clie : 0;
    const size = Math.floor(inputSize / textSize * maxFontSize);
    const newSize = size > maxFontSize ? maxFontSize : size;
    if (minFontSize && newSize <= minFontSize) {
      setCalculatedFontSize(minFontSize);
    } else {
      setCalculatedFontSize(newSize);
    }
  };
  useEffect(() => {
    resizeFontSize();
  }, [value]);
  const handleChange = e => {
    const value = e.target.value;
    if (maxDigits && value.length > maxDigits) {
      return;
    }
    onChange(e);
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", _extends({
    type: "text"
  }, inputProps, {
    style: {
      fontSize: calculatedFontSize
    },
    className: classnames(classes.input, className),
    value: value,
    onChange: handleChange,
    ref: inputRef
  })), /*#__PURE__*/ReactDom.createPortal( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: maxFontSize
    },
    className: classnames(classes.text),
    ref: textRef
  }, value)), document.body));
}